import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center mb-4" }
const _hoisted_2 = { class: "text-xl font-bold" }
const _hoisted_3 = { class: "mb-4" }




export default /*@__PURE__*/_defineComponent({
  __name: 'modal',
  props: {
  show: { type: Boolean, default: false },
  title: { type: String, default: '' },
  size: { type: String, default: 'max-w-md' }, // can be max-w-lg, max-w-xl etc.
},
  emits: ['close'],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.$emit('close')), ["enter"])),
            tabindex: "0"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["bg-white rounded-md shadow-xl w-full p-4", __props.size]),
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                  class: "text-gray-500 hover:text-gray-700"
                }, " ✕ ")
              ]),
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ], 2)
          ], 32))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})